"use client";

import { cn, Icon, Modal, Tooltip } from "@kyan/ui";

import { OneClickTradingModalContent } from "./components/OneClickTradingModalContent/OneClickTradingModalContent";
import { useOneClickTradingModalController } from "./OneClickTradingModal.controller";

export const OneClickTradingModal: React.FC = () => {
  const {
    setShowOneClickTradingModal,
    showOneClickTradingModal,
    handleClick,
    isLoading,
    isTradingSessionEnabled,
    isDisabled,
  } = useOneClickTradingModalController();

  return (
    <div className="hidden h-full items-center justify-center pr-3.5 lg:flex xl:w-10 2xl:w-12">
      <Tooltip
        avoidCollisions
        side="bottom"
        align="center"
        content={`One-Click Trading ${isTradingSessionEnabled ? "Enabled" : "Disabled"}`}
      >
        <Icon
          size="xl"
          name="one-click"
          hoverEffect="circle"
          disabled={isDisabled}
          className={cn("flex size-10 items-center justify-center", {
            "text-primary": isTradingSessionEnabled,
            "opacity-70": isLoading,
          })}
          onClick={handleClick}
        />
      </Tooltip>

      <Modal
        shouldScroll={false}
        open={showOneClickTradingModal}
        onOpenChange={setShowOneClickTradingModal}
      >
        <OneClickTradingModalContent />
      </Modal>
    </div>
  );
};
